import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

import variables from '../../../contexts/ThemeProvider/variables';

const OuterContainer = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  // this z-index is needed to hide the MUI icons on the sidebar underneath
  zIndex: 1300,
  padding: 48,
  backgroundColor: variables.white,
});

const InnerContainer = styled(Box)({
  height: '100%',
  borderRadius: 2,
  padding: 3,
  display: 'flex',
  flexDirection: 'column',
});

interface IProps {
  title: string;
  onClose: () => void;
  children: React.ReactElement;
}

export const AddSection: React.FC<IProps> = ({ title, onClose, children }) => {
  return (
    <OuterContainer>
      <InnerContainer>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, ml: -2 }}>
          <IconButton onClick={onClose} sx={{ alignSelf: 'flex-start' }}>
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="h6">{title}</Typography>
        </Box>
        {children}
      </InnerContainer>
    </OuterContainer>
  );
};
